<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">货品管理</el-breadcrumb-item>
        <el-breadcrumb-item>待回货管理</el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <el-form :model="query" ref="query" label-width="90px" class="search-form">
      <el-row>
        <el-form-item label="关键词" prop="keyword">
          <el-col style="width: 160px">
            <el-input v-model="query.keyword" @keyup.enter="fetchs" prefix-icon="Search"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="流程类型">
          <el-select v-model="template" placeholder="全部类型" clearable @change="fetchs" style="width: 150px">
            <el-option label="维修" value="repair"></el-option>
            <el-option label="融金" value="gold"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结案方式">
          <el-select v-model="completionMode" placeholder="全部方式" clearable @change="fetchs" style="width: 150px">
            <el-option label="回货入库" value="return"></el-option>
            <el-option label="回款结案" value="cash"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="showOrgFilters" label="所属公司">
          <el-tree-select ref="companys" v-model="companyId" :data="companys" @change="fetchs()"
            check-strictly :render-after-expand="false" style="min-width: 210px;" />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="单据时间">
          <el-date-picker v-model="dateRange" type="daterange" start-placeholder="开始时间" end-placeholder="结束时间"
            unlink-panels :shortcuts="$util.getShortCuts()" @change="fetchs()" style="max-width:210px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="单据状态" prop="status">
          <el-select v-model="status" placeholder="请选择单据状态" @change="fetchs" clearable style="width: 180px">
            <el-option label="待负责人审核" value="0"></el-option>
            <el-option label="待复核" value="11"></el-option>
            <el-option label="待库管审核" value="21"></el-option>
            <el-option label="已完成" value="1"></el-option>
            <el-option label="已取消" value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" label-width="20px">
          <el-button type="primary" icon="Search" @click="fetchs()">搜索</el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="toolbar">
      <el-button type="primary" icon="Plus" @click="openDetail('repair')">新增维修出库待回货</el-button>
      <el-button type="primary" icon="Money" plain @click="openDetail('gold')">新增融金出库待回货</el-button>
    </div>

    <basic-table ref="table" class="table" :query="query" @handler="fetchs">
      <template v-slot:companyId="scope">
        <span>{{ companyName(scope.row.companyId || scope.row.companyID) }}</span>
      </template>
      <template v-slot:billSource="scope">
        <el-tag size="small" :type="sourceTemplate(scope.row.billSource) == 'gold' ? 'warning' : ''">
          {{ sourceText(scope.row.billSource) }}
        </el-tag>
      </template>
      <template v-slot:status="scope">
        <el-link :type="statusType(scope.row.status)" size="small" disabled>{{ statusText(scope.row.status, scope.row.billSource) }}</el-link>
      </template>
      <template v-slot:toolbar="scope">
        <el-link @click="openDetail(sourceTemplate(scope.row.billSource), scope.row)" type="primary" size="small" style="margin:5px;">
          {{ scope.row.status == 1 ? '查看' : '去处理' }}
        </el-link>
        <el-link v-if="scope.row.status == 1" @click="openBillDetail(scope.row)" type="success" size="small"
          style="margin:5px;">库存明细</el-link>
      </template>
    </basic-table>
  </el-card>
</template>

<script>
import BasicTable from "@/components/basic-table.vue";

export default {
  name: "StockBills",
  components: { BasicTable },
  data() {
    return {
      dateRange: [],
      status: "",
      template: "",
      completionMode: "",
      companys: [],
      companyId: "",
      query: {
        keyword: "",
        columns: [
          { type: "selection", width: "55" },
          { type: "index", label: "序号" },
          { prop: "billType", label: "单据类型", sortable: true, searchable: true, width: "110", showOverflowTooltip: true },
          { type: "template", prop: "billSource", label: "流程", sortable: true, searchable: true, width: "110", showOverflowTooltip: true },
          { prop: "billCode", label: "单据编号", sortable: true, searchable: true, width: "150", showOverflowTooltip: true },
          { type: "template", prop: "companyId", label: "公司", sortable: true, searchable: true, width: "130", showOverflowTooltip: true },
          { prop: "netCode", label: "关联单号", sortable: true, searchable: true, width: "130", showOverflowTooltip: true },
          { prop: "productNumber", label: "数量", width: "60" },
          { prop: "costTotal", label: "金额", sortable: true, width: "90" },
          { prop: "billDate", label: "单据时间", width: "140", sortable: true, showOverflowTooltip: true },
          { type: "template", prop: "status", label: "状态", width: "110", searchable: true },
          { prop: "operatorName", label: "申请人", sortable: true, searchable: true, width: "80" },
          { prop: "handoverName", label: "负责人", searchable: true, width: "80" },
          { prop: "reviewerName", label: "复核", searchable: true, width: "80" },
          { prop: "financerName", label: "财务", searchable: true, width: "80" },
          { prop: "reason", label: "备注", searchable: true, width: "220", showOverflowTooltip: true },
          { prop: "createDate", label: "创建时间", width: "150", sortable: true, showOverflowTooltip: true },
          { prop: "createUserName", label: "创建人", sortable: true, searchable: true, width: "90" },
          { type: "toolbar", label: "操作", width: "150" },
        ],
        filters: [],
        sidx: "billDate",
        sord: "desc"
      }
    };
  },
  mounted() {
    this.template = this.defaultTemplate();
    this.$kaung.init(this.$options.name);
    this.$kaung.initCompanys(this, this.fetchs);
  },
  methods: {
    defaultTemplate() {
      if (this.$route.query.template) return this.$route.query.template;
      if (this.$route.path.indexOf("/repair") >= 0) return "repair";
      if (this.$route.path.indexOf("/gold") >= 0) return "gold";
      return "";
    },
    fetchs() {
      this.query.filters = [{ name: "billType", value: "待回货流程", operate: 0 }];
      if (this.template && this.completionMode) {
        this.query.filters.push({ name: "billSource", value: this.template + ":" + this.completionMode, operate: 0 });
      } else if (this.template) {
        this.query.filters.push({ name: "billSource", value: this.template + ":return," + this.template + ":cash", operate: 6 });
      } else if (this.completionMode) {
        this.query.filters.push({ name: "billSource", value: "repair:" + this.completionMode + ",gold:" + this.completionMode, operate: 6 });
      }
      if (this.dateRange && this.dateRange[0]) {
        this.query.filters.push({ name: "billDate", value: this.$util.fmtDate(this.dateRange[0], "yyyy-MM-dd"), operate: 2 });
      }
      if (this.dateRange && this.dateRange[1]) {
        this.query.filters.push({ name: "billDate", value: this.$util.fmtDate(this.dateRange[1], "yyyy-MM-dd") + " 23:59:59", operate: 4 });
      }
      if (this.showOrgFilters) {
        if (!this.companyId || this.companyId.length == 0) {
          this.companyId = this.$store.getters.getUserInfo?.companyID || "";
        }
        if (this.companyId && this.companyId.length > 0) {
          this.query.filters.push({ name: "companyId", value: this.companyId, operate: 6 });
        }
      }
      if (this.status) {
        this.query.filters.push({ name: "status", value: this.status, operate: 0 });
      }
      let { data, records, total, ...params } = { ...this.query };
      this.$kaung.search(params).then((res) => {
        this.query = { ...res.data };
      });
    },
    openDetail(template, row) {
      this.$router.push({ path: "/stock/bills/pendingReturnDetail", query: { id: row?.id || "", template: template || this.template || "repair" } });
    },
    openBillDetail(row) {
      this.$router.push({ path: "/stock/bills/detail", query: { billCode: row.billCode } });
    },
    sourceTemplate(value) {
      return (value || "").split(":")[0] || "repair";
    },
    sourceMode(value) {
      return (value || "").split(":")[1] || (this.sourceTemplate(value) == "gold" ? "cash" : "return");
    },
    sourceText(value) {
      const templateText = this.sourceTemplate(value) == "gold" ? "融金" : "维修";
      const modeText = this.sourceMode(value) == "cash" ? "回款" : "回货";
      return templateText + "/" + modeText;
    },
    statusText(status, source) {
      const reviewText = this.sourceTemplate(source) == "gold" ? "待财务复核" : "待成本复核";
      const map = { 0: "待负责人审核", 11: reviewText, 21: "待库管审核", 1: "已完成", "-1": "已取消" };
      return map[status] || "其他";
    },
    statusType(status) {
      const map = { 0: "primary", 11: "warning", 21: "warning", 1: "success", "-1": "danger" };
      return map[status] || "info";
    },
    companyName(companyId) {
      const match = this.findCompany(companyId, this.companys);
      return match?.label || match?.companyName || match?.name || companyId || "";
    },
    findCompany(companyId, list) {
      if (!companyId || !Array.isArray(list)) return null;
      for (const item of list) {
        if (item.id == companyId || item.value == companyId) return item;
        const child = this.findCompany(companyId, item.children);
        if (child) return child;
      }
      return null;
    }
  },
  watch: {
    "$route.path"() {
      this.status = "";
      this.template = this.defaultTemplate();
      this.fetchs();
    },
    "$route.query.template"() {
      this.template = this.defaultTemplate();
      this.fetchs();
    },
    companyId(newValue, oldValue) {
      if (newValue && newValue != oldValue) {
        this.$util.setLocalstorage("companyIdStr", newValue);
      } else {
        this.$util.setLocalstorage("companyIdStr", "");
      }
    }
  }
};
</script>
